import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AddressIcon } from '../../../icons';
import { DocumentStatus } from '../../../types';
import { ProgressStatusCard } from '../../../components';
import { DocumentsToaster } from '../DocumentsToaster';
import { STATUS_ICONS_MAP } from '../constants';
import '../VerifyIdentityStep.scss';
export const AddressVerificationCard = ({ addressScenario, isDisabled, count, onChooseDocumentType, }) => {
    const { t } = useTranslation();
    const [isOpenToaster, setIsOpenToaster] = useState(false);
    if (!addressScenario) {
        return null;
    }
    const { scenarioType, status, payload } = addressScenario;
    const supportedDocuments = payload.supportedDocuments;
    const handleChangeToasterState = () => {
        setIsOpenToaster((prev) => !prev);
    };
    const handleChooseDocumentType = (documentType) => {
        onChooseDocumentType(scenarioType, documentType);
    };
    const isPendingState = status === DocumentStatus.REQUIRED || status === DocumentStatus.PENDING || status === DocumentStatus.NOT_UPLOADED;
    const isSubmittedState = status === DocumentStatus.SUBMITTED;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "verify-identity__inner-content" },
            React.createElement("div", { className: "verify-identity__inner-content__header" },
                React.createElement("div", { className: "verify-identity__inner-content__header__inner" },
                    React.createElement(AddressIcon, { width: 24, height: 24 }),
                    React.createElement("p", null, t('verify_identity_screen.verify_your_address', { count }))),
                STATUS_ICONS_MAP.get(status)),
            !isDisabled && isPendingState && (React.createElement(React.Fragment, null,
                React.createElement("p", { className: "verify-identity__inner-content__description" }, t('verify_identity_screen.verify_your_address_description')),
                React.createElement("ul", { className: "verify-identity__inner-content__list" }, supportedDocuments.map((doc) => (React.createElement("li", { key: doc }, t(`common.${doc.toLowerCase()}`))))))),
            isPendingState ? (React.createElement("button", { className: "verify-identity__inner-content__button", disabled: isDisabled, onClick: handleChangeToasterState }, t('verify_identity_screen.start_btn'))) : (React.createElement("div", { className: `verify-identity__inner-content__status verify-identity__inner-content__status--${status.toLowerCase()}` },
                React.createElement("span", { className: "verify-identity__inner-content__status__text" }, t(`verify_identity_screen.${status.toLowerCase()}`)))),
            isSubmittedState && React.createElement(ProgressStatusCard, null)),
        React.createElement(DocumentsToaster, { isOpen: isOpenToaster, supportedDocuments: supportedDocuments, onClose: handleChangeToasterState, onClick: handleChooseDocumentType })));
};
//# sourceMappingURL=AddressVerificationCard.js.map